import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpResponse } from 'selenium-webdriver/http';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../../services/user.service';
import { EbUser } from '../../../../classes/user';
import { RequestProcessing } from '../../../../utils/requestProcessing';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Statique } from '../../../../utils/statique';
import { ModalService } from '../../../../shared/modal/modal.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../../account.component.css']
})
export class ResetPasswordComponent implements OnInit {

  user = new EbUser();
  model: any = {};
  resetEmail = false;
  resetPassword = false;
  token = null;
  error = '';
  info = '';

  constructor(protected authenticationService :AuthenticationService ,private router: Router, private userService: UserService, private translate: TranslateService,
     private modalService: ModalService) { }

  ngOnInit() {
    this.authenticationService.logout ();
    this.router.routerState.root.queryParams
      .subscribe(params => {
        if (params['token']) {
          this.resetEmail = false;
          this.resetPassword = true;
          this.token = params['token'];
          //          this.user.resetToken = params['token'];
        } else {
          this.resetEmail = true;
          this.resetPassword = false;
        }
      });
      Statique.hideSideBar=true;
  }

  reset(event: any) {
    let requestProcessing = new RequestProcessing();
    requestProcessing.beforeSendRequest(event);
    this.userService.resetPassword(this.model.email)
      .subscribe(
      result => {
        console.log(result);
        requestProcessing.afterGetResponse(event);

        if (result == 1) {
          this.error = null;
          this.translate.get('RESET_PASSWORD.MSG_RESETED_PASSWORD').subscribe((res: string) => {
            this.info = res;
          });

        } else if (result == -1) {
          this.info = null;
          this.translate.get('RESET_PASSWORD.MSG_EMAIL_NOT_FOUND').subscribe((res: string) => {
            this.info = res;
          });
        } else if (result == 2) {
          this.info = null;
          this.translate.get('RESET_PASSWORD.MSG_DISACTIVE').subscribe((res: string) => {
            this.info = res;
          });
        } else if (result == 3) {
          this.info = null;
          this.translate.get('RESET_PASSWORD.MSG_NON_ACTIF').subscribe((res: string) => {
            this.info = res;
          });
        }
      }
      );
  }

  changePassword(event: any) {
    //  this.user.email = this.model.email;
    let  $this = this;
    if (this.model.password != this.model.password2) {
      this.info = null;
      this.error = 'Pas identiques'
    } else {

      this.user.password = this.model.password;
      this.user.resetToken = this.token;
      let requestProcessing = new RequestProcessing();
      requestProcessing.beforeSendRequest(event);
      this.userService.changePassword(this.user)
        .subscribe(
        result => {
          requestProcessing.afterGetResponse(event);
          if (result) {
            this.error = null;
            this.translate.get('RESET_PASSWORD.MSG_UPDATED_PASSWSORD').subscribe((res: string) => {
              this.info = res;
            });
            this.modalService.information("information", this.info, function(){
              $this.router.navigate(["login"]);
            })

          }
          else {
            this.info = null;
            this.translate.get('RESET_PASSWORD.MSG_TOKEN_NOT_FOUND').subscribe((res: string) => {
              this.info = res;
            });
          }
        });

    }


  }
  ngOnDestroy() {
    Statique.hideSideBar=false;
  }
}



// WEBPACK FOOTER //
// ./src/app/component/account/login/reset-password/reset-password.component.ts